var _excluded = ["header", "description", "primaryButton", "secondaryButton", "children", "footer", "asset", "assetAspectRatio", "shouldHideCloseButton", "aria-label"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { ConditionalWrapper } from '../../../components/internal/ConditionalWrapper';
import { useBreakpointValue } from '../../../theme';
import { themeSpaces } from '../../../theme/foundations';
import { forwardRef } from '../../../utils';
import { Container } from '../../Container';
import { BaseModal } from '../BaseModal';
import { PromotionalModaFooter } from './components';
import { PromotionalModalHeader } from './components/PromotionalModalHeader';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PromotionalModal = forwardRef((_ref, ref) => {
  var {
    header,
    description,
    primaryButton,
    secondaryButton,
    children,
    footer,
    asset,
    assetAspectRatio = '7 / 3',
    shouldHideCloseButton,
    'aria-label': ariaLabel = header
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var bodyElementPaddingTop = useBreakpointValue({
    xs: shouldHideCloseButton ? 'm' : "calc(".concat(themeSpaces.m, " + ").concat(themeSpaces.m, ")"),
    s: shouldHideCloseButton ? 'xxl' : "calc(".concat(themeSpaces.xxl, " + ").concat(themeSpaces.xs, ")")
  });
  return /*#__PURE__*/_jsxs(BaseModal, _objectSpread(_objectSpread({
    "data-component": "PromotionalModal"
  }, props), {}, {
    shouldHideCloseButton: shouldHideCloseButton,
    "aria-label": ariaLabel,
    ref: ref,
    children: [/*#__PURE__*/_jsx(PromotionalModalHeader, {
      headerTitle: header,
      description: description,
      assetAspectRatio: assetAspectRatio,
      children: asset
    }), /*#__PURE__*/_jsx(ConditionalWrapper, {
      condition: React.Children.count(children) > 1,
      wrapper: children => /*#__PURE__*/_jsx(Container, {
        paddingTop: bodyElementPaddingTop,
        children: children
      }),
      children: /*#__PURE__*/_jsx(BaseModal.Body, {
        children: children
      })
    }), /*#__PURE__*/_jsx(PromotionalModaFooter, {
      primaryButton: primaryButton,
      secondaryButton: secondaryButton,
      children: footer
    })]
  }));
});
PromotionalModal.displayName = 'PromotionalModal';
//# sourceMappingURL=PromotionalModal.js.map